import { render, staticRenderFns } from "./AddNewDataSidebar.vue?vue&type=template&id=1d84415e&scoped=true&"
import script from "./AddNewDataSidebar.vue?vue&type=script&lang=js&"
export * from "./AddNewDataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDataSidebar.vue?vue&type=style&index=0&id=1d84415e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84415e",
  null
  
)

export default component.exports